import axios from 'axios';

// Use relative URL so API calls go to same domain as frontend (works on both preview and custom domain)
const API = '/api';

// Create axios instance with interceptors for auth
const api = axios.create({
  baseURL: API,
  withCredentials: true
});

// Add request interceptor to include Authorization header
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('session_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear stored token on 401
      localStorage.removeItem('session_token');
    }
    return Promise.reject(error);
  }
);

export default api;
export { API };
